<template>
  <!-- eslint-disable -->
  <div class="login-content">
    <div id="container">
      <div id="zjz">
        <div class="dl" style="margin-top: 100px;">
          <div id="any2" class="jg">
            <img src="/virexp/s/themes/default/img/login/tanhao.png" width="14" height="14">
            用户名或密码不正确
            <br>
          </div>
          <div class="dlnr">
            <form id="loginForm" name="loginForm" onsubmit="return validateForm_loginForm();"
            action="/virexp/login" method="post">
              <input type="hidden" name="submitTimes" value="-1" id="loginForm_submitTimes">
              <input type="hidden" name="next" value="" id="loginForm_next">
              <input type="hidden" name="nextLoginUrl" value="" id="loginForm_nextLoginUrl">
              <input type="hidden" name="struts.token.name" value="token">
              <input type="hidden" name="token" value="CXZHFCFE4SQDZI4VVT4OORWNH1YLNREG">
              <div style="width:280px;text-align:center;">
                <span>
                </span>
              </div>
              <div style="height:29px;line-height:29px;margin-bottom:29px;">
                <span>
                  用户名
                  <label for="loginForm_account">
                  </label>
                </span>
                <span>
                  <input type="text" name="account" size="22" maxlength="20" value="" id="account">
                </span>
              </div>
              <div style=" height:29px;line-height:29px;margin-bottom:29px;">
                <span style="margin-right: 10px;">
                  密 &nbsp;&nbsp;&nbsp;&nbsp; 码
                  <label for="loginForm_password">
                  </label>
                </span>
                <span>
                  <input type="password" name="password" size="22" id="loginForm_password">
                </span>
              </div>
              <div class="fieldSet" style="margin-bottom: 6px;">
                <span style="float:left;">
                  验证码：
                </span>
                <a style="float:left;margin-right:10px;">
                  <img id="checkImg" class="captchaImage" src="/api/virexp/getPIC" onclick="change()"
                  title="点击更换验证码" style="height:29px;">
                </a>
                <span>
                  <input type="text" id="checkcode" name="checkcode" class="text captcha"
                  maxlength="4" autocomplete="off" style="    width: 126px; float: left;">
                </span>
                <div style="clear:both;">
                </div>
              </div>
              <div class="clearfix" style="height:15px;line-height:15px;font-size:14px;">
                <div class="remember fl" :class="[chk ? 'remember1' : '']"
                  @click="chk = !chk">
                  <input id="remember_me" type="checkbox" value="">
                  记住密码
                </div>
                <span class="fr">
                  忘记密码，请
                  <router-link to="/forget">点击这里</router-link>
                </span>
              </div>
              <div class="footer">
                <div style="margin-left: 17%;">
                  <input id="dlan" type="button" value="登    录">
                  <router-link to="/register" id="zhuce" tag="button">立即注册</router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div id="zjx">
        <div id="dizi" style="margin: 30px;">
          <span>
            版权所有&nbsp;华南农业大学&nbsp;&nbsp;2010-2020&nbsp;&nbsp;
          </span>
          <br>
          <br>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
 /* eslint-disable */
export default {
  name: 'Login',
  components: {
  },
  data () {
    return {
      chk: false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
 /* eslint-disable */
  ul {list-style:none;text-decoration: none;}
  img {border:0px;}
  a{TEXT-DECORATION:none;}
  html, body, div, p, ul, li, dl, dt, dd, h1, h2, h3, h4, h5, h6, form, input, select, button, textarea, iframe, table, th, td { margin: 0; padding: 0; }
  /*清除浮动*/
  .clearfix:after { content:""; display:block; clear:both; height:0; line-height:0; visibility:hidden; }
  .clearfix { zoom:1; }
  
  .fl{float:left;}
  .fr{float:right;}
  .login-content {
  	background:#1085ba;
  	text-decoration: none;
  	font-family: "宋体";
    height: 100vh;
    overflow: hidden;
  }
  	
  #dilogo{
  	width: 111px;
  	height:20px;
  	background-image: url(http://xnfzsyjx.scau.edu.cn/virexp/s/login/default/img/dilogo.png);
  	background-repeat: no-repeat;
  	margin-top: 7px;
  	margin-left: 31px;
  	float: left;
  }
  #dizi2{
  	height:12px;
  	margin-top: 14px;
  	margin-left: 7px;
  	float: left;
  	font-size: 12px;
  	color: #748aab;
  	font-family: Arial, Helvetica, sans-serif;
  }
  .jg{
  	height:20px;
  	width: 170px;
  	float: left;
  	margin-left: 42px;
  	font-size: 12px;
  	line-height: 18px;
  	color: #042a58;
  	position:relative;
  	display:none;
  }
  #any2{ position:absolute;}
  #textfield{
  	height: 16px;
  	width: 160px;
  	font-size: 12px;
  }
  #textfield2{
  	height: 16px;
  	width: 80px;
  	font-size: 12px;	
  }
  #textfield3
  {
  	height: 16px;
  	width: 160px;
  	font-size: 12px;	
  }
  #yzm{
  	float: left;
  	height: 16px;
  	width: 46px;
  	font-size: 12px;
  	background-image: url(http://xnfzsyjx.scau.edu.cn/virexp/s/login/default/img/yzm.jpg);
  	background-repeat: no-repeat;
  	margin-top: 1px;
  	margin-left: 1px;
  	left: 165px;
  }
  #gouxuan{
  	line-height: 25px; 
  	float: left;
  	height: 25px;
  	width: 74px;
  	padding-left:40px;
  	padding-top:8px !important;
  }
  
  #container {
  	width:902px;
  	margin: 150px auto 0;
  } 
  #zjz{
  	z-index: -100;
  	width: 902px;
  	height:382px;
  	background: url(http://xnfzsyjx.scau.edu.cn/virexp/s/login/default/img/login.png) no-repeat center top;
  }
  .dl{
  	width: 324px;
  	float: left;
  	margin-top: 131px;
  	margin-left: 480px;
  	font-size: 16px;
  	line-height: 18px;
  	color: #fff;;
  }
  .dlnr{ 
  	margin-top:0px;
  }
  input[type = "password"], input[type = "text"]{
  	height: 28px;
  	line-height:28px;
  	width:260px;
      border-radius: 0px !important;
      background: url(http://xnfzsyjx.scau.edu.cn/virexp/s/login/default/img/bg-login.png) repeat-x left top;
      border: 1px solid #35b4d5 !important;
      border-left:none;
      border-top:none;
      text-indent:5px;
      color:#fff;
  }
  .errorMessage{
  	padding-left:50px;
  }
  .remember{
  	background:url(http://xnfzsyjx.scau.edu.cn/virexp/s/login/default/img/bg-remember.png) no-repeat left center;
  	margin-left: 56px;
    cursor: pointer;
  }
  .remember1{
  	background:url(http://xnfzsyjx.scau.edu.cn/virexp/s/login/default/img/jizhu.png) no-repeat left center;
  }
  .remember input{
  	opacity:0;
  	filter:alpha(opacity=0);
  	margin-right:10px;
  }
  #dlan,#zhuce {
  	float: left;
  	height: 35px;
  	width: 119px;
  	line-height: 35px;
  	font-size: 14px !important;
  	text-align: center;
  	background: url(http://xnfzsyjx.scau.edu.cn/virexp/s/login/default/img/bg-deng.png) repeat-x left top;
  	color: #FFF;
  	cursor: pointer;
  	border: none !important;
  }
  #zhuce{
  	background: url(http://xnfzsyjx.scau.edu.cn/virexp/s/login/default/img/bg-zhuce.png) repeat-x left top;
  	margin-left:30px;
  }
  /*footer*/
  #zjx{
  	width: 800px;
  	height:107px;
  	background-image: none;
  	background-repeat: no-repeat;
  	color:#1e3b71;
  }
  #dizi{
  	height:12px;
  	margin-top: 14px;
  	margin-left: 7px;
  	float: left;
  	font-size: 12px;
  	width: 800px;
  	text-align: center;
  }
  .footer{
  	width:324px; 
  	text-align:center; 
  	margin-top:28px !important;
  }
</style>